import { authUserByInitData } from "../api/customerAPI";

const authUser = async (initData) => {
    try {
        if (!initData) {
            throw new Error("Missing data to authenticate");
        }

        const authResponse = await authUserByInitData(initData);
        console.log('returned token:', authResponse.token);

        if (authResponse && authResponse.token && authResponse.refreshToken) {
            localStorage.setItem("accessToken", authResponse.token);
            localStorage.setItem("refreshToken", authResponse.refreshToken);
            console.log("User authenticated successfully");
            return { res:true, token: authResponse.token };
        }

        return null;


    } catch (error) {
        console.error("Authentication error:", error);
        throw error;
    }
};

export default authUser;
